import { createSlice } from '@reduxjs/toolkit';

export const chatSlice = createSlice({
	name: 'chat',
	initialState: {
		open: false,
	},
	reducers: {
		// setTransparent: (state) => {
		// 	state.variant = 'transparent';
		// },
		// setOpaque: (state) => {
		// 	state.variant = 'opaque';
		// },
		// setSmoke: (state) => {
		// 	state.variant = 'smoke';
		// },
		setOpen: (state, action) => {
			state.open = action.payload;
		}
	}
});

export const { setOpen } = chatSlice.actions;

export default chatSlice.reducer;